import React from "react";
import { HelperShell } from "@/pages/chef/ChefHelper";

export default function SalarieHelper() {
  return <HelperShell role="salarie" />;
}
